import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Dialog,
  Divider,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  Chip,
  Box,
  Alert,
} from "@mui/material";
import CustomButton from "../../reusableComponents/CustomButton";
import { colorBrandObject } from "../../../constants/brandings";
import { useAuth } from "../../context/API_Client";
import {
  formatDateToUTC,
  fortmatTimezoneToUTC,
  generateDateTimezone,
  isEmpty,
} from "../utils/utils";
import "./generateReportModal.css";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import MonthYearPicker from "../../reusableComponents/MonthYearPicker/MonthYearPicker";
import LoadingLogoPage from "../loadingPage/loadingPage";
import { useParams } from "react-router-dom";
const checkBoxStyle = {
  "& .MuiSvgIcon-root": {
    color: colorBrandObject?.secondaryButtonColor,
  },
  "&.Mui-checked": {
    color: colorBrandObject?.secondaryButtonColor,
    "& .MuiSvgIcon-root": {
      fill: colorBrandObject?.secondaryButtonColor,
    },
  },
};

const GenerateReportModal = (props) => {
  const {
    open,
    onClose,
    reconStatusData,
    fileSetCodeData,
    tags,
    setToggleModal,
    dynamicFields,
    fileSetCodesData
  } = props;
  const { reconId } = useParams();
  const [reportTitle, setReportTitle] = useState(`report_${Math.floor(Date.now() / 1000)}`);
  const [reconStatus, setReconStatus] = useState([]);
  const [fileSetCode, setFileSetCode] = useState([]);
  const [reportTitleError, setReportTitleError] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [checkBoxItems, setCheckBoxItems] = useState([]);
  const [selectedCheckBox, setSelectedCheckBox] = useState([])
  const [tagsError, setTagsError] = useState(false)
  const [checkBoxLoader, setCheckBoxLoader] = useState(false);
  const [interInsurerFileCodes, setInterInsurerFileCodes] = useState([])
  const { generateGenericReconReports, getFileSetCodesByTags } = useAuth();
  const isAllFileSetCodeDataSelected = fileSetCodeData.length > 0 && fileSetCode.length === fileSetCodeData.length;
  const isAllReconStatusSelected = reconStatusData.length > 0 && reconStatus.length === reconStatusData.length;
  const isAllTagsSelected = tags.length > 0 && selectedTags.length === tags.length;

  const handleFileSetCodeChange = (event) => {
    const value = event.target.value;
    console.log("value:", value);
    console.log("fileSetCodeData:", fileSetCodeData);

    if (value[value.length - 1] === "all") {
      setFileSetCode(
        fileSetCode.length === fileSetCodeData.length
          ? []
          : fileSetCodeData.map((d) => d.fileSetCode)
      );
      return;
    }
    setFileSetCode(value);
  };

  const getTitleByFileCode = (selectedFileSetCodeList) => {
    if (selectedFileSetCodeList?.length) {
      const checkBoxItems = fileSetCodeData.filter(el => selectedFileSetCodeList.includes(el.fileSetCode))
      const checkBoxElementsOptions = checkBoxItems.map(el => ({ title: el.fileSetTitle, value: el.fileSetCode }))
      setSelectedCheckBox(checkBoxElementsOptions.map(el => el.value))
      setCheckBoxItems(checkBoxElementsOptions);
    } else {
      setSelectedCheckBox([])
      setCheckBoxItems([])
    }
  }
  const getTagsFieldsData = (value) => {
    if (!value.length) return setInterInsurerFileCodes([])
    setCheckBoxLoader(true)
    getFileSetCodesByTags(value, (data) => {
      if (data?.length) {
        setInterInsurerFileCodes(data)
      } else {
        setInterInsurerFileCodes([])
      }
      setCheckBoxLoader(false)
    }, () => {
      setCheckBoxLoader(false)
    })
    return
  }
  const handleReconStatusChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setReconStatus(reconStatus.length === reconStatusData.length ? [] : reconStatusData.map(d => d.value));
      return;
    }
    setReconStatus(value);
  };
  const handleTagChange = (event) => {
    let value = event.target.value;
    const isSelectingAll = value[value.length - 1] === "all";
    if (isSelectingAll) {
      const allSelected = selectedTags.length === tags.length;
      setSelectedTags(allSelected ? [] : [...tags]);
      value = allSelected ? [] : [...tags];
    } else {
      setSelectedTags(value);
    }
    getTagsFieldsData(value);
  };
  const handleGenerateReport = () => {
    let dateRange = {};
    if (!dateRange.fromDate && !dateRange.toDate && !fileSetCode?.length && !selectedTags?.length) {
      return customToast("error", "high", "Please select any one filter")
    }
    if (!startDate) {
      dateRange = fortmatTimezoneToUTC("last24Months");
    } else {
      dateRange.fromDate = startDate;
      dateRange.toDate = endDate || generateDateTimezone("end");
    }
    let dynamicFieldsFormatted = dynamicFields
    if (checkBoxItems?.length) {
      let allFieldOfInterestArray = [];
      if (selectedCheckBox?.length) {
        const filteredFileSetCode = fileSetCodeData.filter((el) => selectedCheckBox.includes(el.fileSetCode));
        allFieldOfInterestArray = filteredFileSetCode.map((el) => el.fieldsOfInterest);
      } else {
        const formattedVal = checkBoxItems.map((el) => el.value);
        const filteredFileSetCode = fileSetCodeData.filter((el) => formattedVal.includes(el.fileSetCode));
        allFieldOfInterestArray = filteredFileSetCode.map((el) => el.fieldsOfInterest);
      }
      let formattedElement = [];
      allFieldOfInterestArray.forEach((el) => formattedElement.push(...el));
      dynamicFieldsFormatted = formattedElement;
    }

    dynamicFieldsFormatted = dynamicFieldsFormatted.map(el => (`fields.${el}`))
    if (fileSetCodesData && fileSetCodesData?.length) {
      const fileSetCodesDataFormatted = fileSetCodesData.map(el => `fileSetWiseReconValue.${el}##Recon value`)
      dynamicFieldsFormatted = [...fileSetCodesDataFormatted, ...dynamicFieldsFormatted]
    }
    const payload = {
      fromTimestamp: formatDateToUTC(dateRange.fromDate),
      toTimestamp: formatDateToUTC(dateRange.toDate),
      name: reportTitle,
      reconStatuses: reconStatus.filter((item) => item !== ""),
      dynamicFields: dynamicFieldsFormatted,
      fileSetCodes: fileSetCode.filter((item) => item !== ""),
      reconId: reconId,
      legalEntityCode: fileSetCodeData[0]?.legalEntityCode,
    };

    if (selectedTags?.length) {
      payload.tags = selectedTags;
    }

    generateGenericReconReports(
      payload,
      (data) => {
        onClose();
        setTimeout(() => setToggleModal(true), 500);
      },
      (errorMsg) => {
        customToast("error", "high", errorMsg);
      }
    );
  };
  const handleReportTitleChange = (e) => {
    const inputValue = e.target.value;
    setReportTitle(inputValue);
    setReportTitleError(!isEmpty(inputValue) ? "" : "Please enter title");
  };
  const onDelete = (name) => {
    if (name) {
      setSelectedTags((state) => state.filter((el) => el !== name));
    }
  };

  const handleDateChange = (date, type) => {
    if (!date) return;
    const formattedDate = generateDateTimezone(type, date);
    if (type == "start") {
      setStartDate(formattedDate);
      setEndDate(null);
    } else {
      setEndDate(formattedDate);
    }
  };
  const handleCheckBoxClick = (value) => {
    if (selectedCheckBox.includes(value)) {
      setSelectedCheckBox(state => state.filter(el => el != value))
    } else {
      setSelectedCheckBox(state => [...state, value])
    }
  }
  useEffect(() => {
    const uniqueFileSetCodes = [...new Set([...interInsurerFileCodes, ...fileSetCode])];
    getTitleByFileCode(uniqueFileSetCodes)
  }, [interInsurerFileCodes, fileSetCode])
  return (
    <Dialog className="generateReportModal" open={open}
      PaperProps={{
        style: { height: checkBoxItems?.length ? "600px" : "auto" } // Set modal height here
      }}
    >
      <div className="reconGenerateReportContainer">
        <Typography className="SemiboldTwenty font-black-highest">
          <SummarizeOutlinedIcon
            sx={{ color: colorBrandObject.sideBarSelectedOptionBackground }}
          />{" "}
          Generate Report
        </Typography>
        <img
          src="../assets/ic_twotone-close.svg"
          alt="cross"
          onClick={() => onClose()}
          style={{ cursor: "pointer" }}
        />
      </div>
      <Typography
        className="labelRegular font-black-high"
        style={{ padding: "0px 24px" }}
      >
        Download recon report for your business.
      </Typography>
      <Divider style={{ margin: "16px 24px" }} />

      <div className="reconGenerateReportBody" style={{ height: checkBoxItems?.length ? "500px" : "" }}>
        <div className="flexInputContainer">
          <div className="reconFormClass">
            <div className="reconInputContainer">
              <Typography
                className="labelRegular"
                style={{ color: "var(--global-neutral-grey-1100, #2D2B32)" }}
              >
                Title*
              </Typography>
              <TextField
                className="textField"
                variant="outlined"
                placeholder="Enter Title"
                id="outlined-basic"
                size="small"
                fullWidth
                value={reportTitle}
                onChange={(e) => handleReportTitleChange(e)}
                error={reportTitleError}
              />
              {reportTitleError && (
                <div className="errorStyling">
                  <img src="/assets/errorOutline.svg" className="errorImg" />
                  <Typography className="errorMessage">
                    Please enter title
                  </Typography>
                </div>
              )}
            </div>
          </div>

          <div className="reconFormClass">
            <div className="reconInputContainer">
              <Typography
                className="labelRegular"
                style={{ color: "var(--global-neutral-grey-1100, #2D2B32)" }}
              >
                Report Type*
              </Typography>
              <Select
                className="selectField"
                value={reconStatus}
                multiple={true}
                onChange={handleReconStatusChange}
                classes={{ icon: "custom-dropdown-icon" }}
                MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
                displayEmpty
                renderValue={(reconStatus) => (
                  <div className="itemNameStyling">
                    {reconStatus.length > 0
                      ? reconStatus
                        .map(
                          (value) =>
                            reconStatusData.find(
                              (item) => item.value === value
                            )?.title
                        )
                        .join(", ")
                      : "All"}
                  </div>
                )}
              >
                <MenuItem
                  value="all"
                  className="businessUnit businessUnitCheckbox"
                  style={{ padding: "5px 10px", height: "40px" }}
                >
                  <Checkbox
                    sx={checkBoxStyle}
                    checked={isAllReconStatusSelected}
                    indeterminate={
                      reconStatus.length > 0 &&
                      reconStatus.length < reconStatusData.length
                    }
                  />
                  <div
                    className="ellipsisListItem"
                    style={{ paddingLeft: "6px" }}
                  >
                    <ListItemText primary="All" />
                  </div>
                </MenuItem>
                {reconStatusData?.map((item) => (
                  <MenuItem
                    key={item?.value}
                    value={item?.value}
                    className="businessUnit businessUnitCheckbox"
                    style={{ padding: "5px 10px", height: "40px" }}
                  >
                    <Checkbox
                      sx={checkBoxStyle}
                      checked={reconStatus.indexOf(item.value) > -1}
                    />
                    <div
                      className="ellipsisListItem"
                      style={{ paddingLeft: "6px" }}
                    >
                      {item?.title?.length > 12 ? (
                        <Tooltip>
                          <ListItemText primary={item?.title} />
                        </Tooltip>
                      ) : (
                        <ListItemText primary={item?.title} />
                      )}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        </div>

        <div className="flexInputContainer">
          {tags?.length > 0 &&
            <div className="reconFormClass flexInputContainerMargin">
              <div className="reconInputContainer">
                <Typography
                  className="labelRegular"
                  style={{ color: "var(--global-neutral-grey-1100, #2D2B32)" }}
                >
                  Internal Insurer*
                </Typography>
                <Select
                  className="selectField"
                  multiple
                  value={selectedTags}
                  onChange={handleTagChange}
                  displayEmpty
                  required // Makes it required
                  MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
                  renderValue={(tag) => (
                    <>
                      {tag.length > 0
                        ? <div className="itemNameStyling"> {tag
                          .map((value) => tags.find((d) => d === value))
                          .join(", ")}  </div>
                        : <span style={{ color: "#aaa", fontWeight: 300, fontFamily: "Poppins" }}>Select Internal Insurer
                        </span>}
                    </>
                  )}
                >
                  {tags?.length > 0 && (
                    <MenuItem
                      value="all"
                      className="businessUnit businessUnitCheckbox"
                      style={{ padding: "5px 10px", height: "40px" }}
                    >
                      <Checkbox
                        sx={checkBoxStyle}
                        checked={isAllTagsSelected}
                        indeterminate={
                          selectedTags.length > 0 && selectedTags.length < tags.length
                        }
                      />
                      <div className="ellipsisListItem" style={{ paddingLeft: "6px" }}>
                        <ListItemText primary="All" />
                      </div>
                    </MenuItem>
                  )}

                  {tags?.length > 0 ? (
                    tags?.sort().map((option) => (
                      <MenuItem
                        key={option}
                        value={option}
                        className="businessUnit businessUnitCheckbox"
                        style={{ padding: "5px 10px", height: "40px" }}
                      >
                        <Checkbox
                          sx={checkBoxStyle}
                          checked={selectedTags.indexOf(option) > -1}
                        />
                        <div className="ellipsisListItem" style={{ paddingLeft: "6px" }}>
                          <ListItemText primary={option} />
                        </div>
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>
                      <ListItemText primary="No options available" />
                    </MenuItem>
                  )}
                </Select>

                {tagsError && (
                  <div className="errorStyling">
                    <img src="/assets/errorOutline.svg" className="errorImg" />
                    <Typography className="errorMessage">
                      Internal insurer is required
                    </Typography>
                  </div>
                )}


              </div>
            </div>
          }

          <div className="reconFormClass flexInputContainerMargin">
            <div className="reconInputContainer">
              <Typography
                className="labelRegular"
                style={{ color: "var(--global-neutral-grey-1100, #2D2B32)" }}
              >
                Source*
              </Typography>

              <Select
                className="selectField"
                multiple
                value={fileSetCode}
                onChange={handleFileSetCodeChange}
                displayEmpty
                // error={fileSetCodeError}
                required // Makes the field required
                MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
                renderValue={(selected) => (
                  <div className="itemNameStyling">
                    {selected.length > 0
                      ? selected
                        .map((value) =>
                          fileSetCodeData.find((item) => item.fileSetCode === value)
                            ?.fileSetTitle
                        )
                        .join(", ")
                      : <span style={{ color: "#aaa", fontWeight: 300, fontFamily: "Poppins" }}>Select Source</span>}
                  </div>
                )}
              >
                {/* Select All Option */}
                <MenuItem
                  value="all"
                  className="businessUnit businessUnitCheckbox"
                  style={{ padding: "5px 10px", height: "40px" }}
                >
                  <Checkbox
                    sx={checkBoxStyle}
                    checked={isAllFileSetCodeDataSelected}
                    indeterminate={
                      fileSetCode.length > 0 && fileSetCode.length < fileSetCodeData.length
                    }
                  />
                  <div className="ellipsisListItem" style={{ paddingLeft: "6px" }}>
                    <ListItemText primary="All" />
                  </div>
                </MenuItem>

                {/* File Set Code Options */}
                {fileSetCodeData.map((option) => (
                  <MenuItem
                    key={option.fileSetCode}
                    value={option.fileSetCode}
                    className="businessUnit businessUnitCheckbox"
                    style={{ padding: "5px 10px", height: "40px" }}
                  >
                    <Checkbox
                      sx={checkBoxStyle}
                      checked={fileSetCode.indexOf(option.fileSetCode) > -1}
                    />
                    <div
                      className="ellipsisListItem"
                      style={{ paddingLeft: "6px" }}
                    >
                      <ListItemText primary={option.fileSetTitle} />
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          <div className="reconFormClass flexInputContainerMargin">
            <div className="reconInputContainer">
              <Typography
                className="labelRegular"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                  marginBottom: 8,
                }}
              >
                Select Start Month
              </Typography>
              <MonthYearPicker
                label="Pick a Month and Year *"
                minDate="2023-01-01"
                disableFuture={true}
                onChange={(date) => handleDateChange(date, "start")}
              />
            </div>
          </div>
          <div className="reconFormClass flexInputContainerMargin">
            <div className="reconInputContainer">
              <Typography
                className="labelRegular"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                  marginBottom: 8,
                }}
              >
                Select End Month
              </Typography>
              <MonthYearPicker
                label="Pick a Month and Year *"
                minDate={startDate}
                disableFuture={true}
                disabled={!startDate}
                value={endDate}
                onChange={(date) => handleDateChange(date, "end")}
              />
            </div>
          </div>
        </div>

        {checkBoxItems?.length > 0 && (
          <div className=" mt-2 py-2 px-4" style={{ backgroundColor: "#FEFFE6", minHeight: "100px" }}>
            {checkBoxLoader ? <LoadingLogoPage minHeight={"60px"} /> : <>
              <Alert
                style={{
                  backgroundColor: "#FEFFE6",
                  padding: 1,
                  display: "inline-block",
                  marginTop: "6px",
                  "& .MuiAlert-message": {
                    padding: 0,
                  },
                }}
                icon={false}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                    padding: "0 5px",
                  }}
                >
                  <img src="/assets/info-circle-yellow.svg" width={15} />

                  <div>
                    <Typography
                      style={{
                        color: " var(--Global-Neutral-Grey-1300, #0A090B)",
                        fontSize: "12px",
                        fontWeight: 400,
                        textAlign: "left",
                        marginLeft: "5px",
                      }}
                    >
                      Customize your report view by selecting the files you wish to see.
                    </Typography>
                  </div>
                </div>
              </Alert>

              <div style={{ marginLeft: "22px" }}>
                <Typography
                  style={{ fontSize: 14, fontWeight: 500, paddingLeft: "5px" }}
                >
                  Select Files:
                </Typography>

                <div className="mt-1 d-flex  flex-wrap" >
                  {checkBoxItems?.map((el) => {
                    return (
                      <div className="d-flex my-2 align-items-center" style={{ width: "30%" }}>
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: "#D9D9D9",
                              fontSize: "16px"
                            },
                            "&.Mui-checked": {
                              color: colorBrandObject?.secondary,
                              "& .MuiSvgIcon-root": {
                                fill: colorBrandObject?.secondary,
                              },
                            },

                          }}
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            fontSize: "14px",
                            height: "14px",
                            color: "rgba(36, 183, 170, 1)",
                            marginRight: "4px",
                          }}
                          id={el.value}
                          checked={!!selectedCheckBox.includes(el.value)}
                          value={el.value}
                          onChange={() => handleCheckBoxClick(el.value)}
                        />
                        <Typography
                          style={{
                            fontSize: 12,
                            fontWeight: 400,
                            paddingLeft: "5px",
                            cursor: "pointer",
                            // color: selectedCheckBox.includes(el.value) ? "#010102EB" : "#01010299"
                            color: "#010102EB"
                          }}
                          onClick={() => handleCheckBoxClick(el.value)}
                        >

                          <Tooltip title={el.title}>
                            <span
                              style={{
                                maxWidth: "150px",  // Adjust as needed
                                display: "inline",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor: "pointer",
                              }}
                            >
                              {el.title}
                            </span>
                          </Tooltip>
                        </Typography>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
            }
          </div>
        )}
      </div>

      <div
        style={{
          paddingBottom: "24px",
          paddingTop: "24px",
          paddingRight: "24px",
          display: "flex",
          justifyContent: "end",
          boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
        }}
      >
        <CustomButton
          variant={"outlined"}
          size={"sm"}
          type={"secondary"}
          text={"Cancel"}
          onClick={() => onClose()}
        />
        <div style={{ marginLeft: "8px" }}>
          <CustomButton
            variant={"contained"}
            size={"sm"}
            type={"secondary"}
            text={"Generate Report"}
            disabled={reportTitleError?.length > 0 || reportTitle?.length === 0}
            onClick={handleGenerateReport}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default GenerateReportModal;
